(function() {
  var Controller,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.StepController = (function(superClass) {
    extend(StepController, superClass);

    function StepController(scope, transitions, map) {
      this.scope = scope;
      this.transitions = transitions;
      this.map = map;
      if (this.scope.rx.fields_id == null) {
        this.scope.aborted = true;
        return;
      }
      StepController.__super__.constructor.call(this, this.scope, this.transitions);
    }

    StepController.prototype.setUpMap = function() {
      if (this.map == null) {
        return;
      }
      this.mapLayer = this.map.createFeatureGroup();
      this.map.add(this.mapLayer);
      return this.scope.$on('$destroy', (function(_this) {
        return function() {
          return _this.map.remove(_this.mapLayer);
        };
      })(this));
    };

    return StepController;

  })(Controller);

}).call(this);
